<template>
  <v-card class="mt-5" flat>
    <v-card-text class="black--text pa-5">
      <h3>Berikut Detail Jadwal Pertemuan</h3>
      <v-spacer class="my-2" />
      <v-tabs v-model="tab" hide-slider>
        <v-row>
          <template v-for="(item, i) in tabItems">
            <v-col cols="12" :lg="12 / tabItems.length" :key="i">
              <v-tab
                :class="[
                  item.disabled ? 'grey--text grey lighten-3' : i === tab ? 'green lighten-4' : '',
                  'green--text text-capitalize body-2 font-weight-medium',
                ]"
                :disabled="item.disabled"
                :key="i"
                style="border: 1px solid #00bfa5; border-radius: 5px; width: 100% !important; max-width: 100%; height: 100%"
              >
                {{ item.disabled ? '' : item.title }}
              </v-tab>
            </v-col>
          </template>
        </v-row>

        <v-tab-item class="mt-2" v-for="(item, i) in tabItems" :key="i">
          <v-row dense class="pa-4 white--text mb-4 mt-3" style="background-color: #39C57B; margin: 0 1px">
            <v-col cols="12" lg="8">
              <div class="body-1">
                Pilih salah satu periode yang tersedia untuk melihat detail dari laporan <br />
                <b>{{ $getDeepObj(detail, 'nama') || '-' }}</b>
              </div>
            </v-col>
            <v-col cols="12" lg="4" class="text-right">
              <v-menu>
                <template v-slot:activator="{ attrs, on }">
                  <v-btn
                    depressed
                    x-large
                    style="background-color: #FDFFCF; border-radius: 5pt"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-row dense>
                      <v-col cols="10" class="text-left">
                        <span style="font-size: 10px" class="text-lowercase">
                          <span class="text-capitalize">Jadwal</span> yang ditampilkan
                        </span>
                        <p class="success--text mb-0 text-capitalize">
                          {{ (mPertemuan && mPertemuan[pendampingan_ke]) || '-' }}
                        </p>
                      </v-col>
                      <v-col cols="2">
                        <v-icon right dark color="#39C57B" class="pt-5">mdi-chevron-down</v-icon>
                      </v-col>
                    </v-row>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item-group color="primary">
                    <template v-for="(item, key) in listPertemuan">
                      <v-divider v-if="key !== 0" :key="`divider-${key}`"></v-divider>
                      <v-list-item :key="item" link @click="onChangePendampinganKe(item)">
                        <v-list-item-title v-text="mPertemuan[item]"></v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-list-item-group>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
          <detail-laporan-list
            ref="laporan"
            :psp-kp-pa="detail"
            :psp-kp-pa-pendampingan="pspKpPaPendampingan"
            :sekolahs="sekolahs"
            :config="config"
            :type="type"
            :meta="meta"
            :refleksi-baru="refleksi_baru"
            @refresh="onRefresh"
          />
        </v-tab-item>
      </v-tabs>
    </v-card-text>
  </v-card>
</template>

<script>
import DetailLaporanList from './LaporanList';
import { mapActions } from 'vuex';

export default {
  name: 'DetailLaporan',
  components: { DetailLaporanList },
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
    config: {
      type: Object,
      default: () => {},
    },
    periodes: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tab: null,
      pendampingan_ke: null,
      component: null,
      refleksi_baru: false,
      pspKpPaPendampingan: {},
      sekolahs: [],
      meta: {},
    };
  },
  mounted() {
    this.tab = 0;
  },
  computed: {
    tabItems() {
      const tahunKe = { 1: 3, 2: 2, 3: 1 };

      return [
        { title: 'Laporan Kunjungan Lapangan', component: 'kunjungan' },
        {
          title: 'Laporan Refleksi Satuan Pendidikan',
          component: 'refleksi',
          disabled: +this.detail['tahun_ke'] >= tahunKe[this.detail.gelombang],
        },
      ];
    },

    type() {
      return this.tab === 1 ? 'refleksi' : 'visitasi';
    },

    mPertemuan() {
      if (this.tab === 1) {
        return this.config['pendampingan_ke-refleksi'] || {};
      }

      return this.config['pendampingan_ke-visitasi'] || {};
    },

    listPertemuan() {
      return Object.keys(this.mPertemuan);
    },
  },
  methods: {
    ...mapActions('laporan', ['fetch']),

    onChangeTab(value) {
      this.pendampingan_ke = this.periodes[`pendampingan_ke-${value === 1 ? 'refleksi' : 'visitasi'}`];
    },

    onChangePendampinganKe(value) {
      this.pendampingan_ke = value;
      this.refleksi_baru = value > this.periodes['pendampingan_ke-refleksi'];
    },

    getListSekolah(reset = false) {
      // get pspKpPaPendampingan
      const pspKpPaPendamingans = (this.$getDeepObj(this.detail, 'psp_kp_pa_pendampingans.data') || []).filter(
        (pendampingan) => +pendampingan.pendampingan_ke === +this.pendampingan_ke
      );
      this.pspKpPaPendampingan = pspKpPaPendamingans[0] || {};

      // get Sekolahs
      const pspKpPaPendampinganId = this.pspKpPaPendampingan.psp_kp_pa_pendampingan_id || '';
      const endpoint = +this.tab === 1 ? 'sekolah' : 'sekolah-visitasi';
      const attr = { endpoint: `pendampingan-lingkup/${pspKpPaPendampinganId}/${endpoint}`, cache: true, reset };
      const params = { count: 20 };

      if (!pspKpPaPendampinganId) return;

      this.fetch({ attr, params }).then(({ data, meta }) => {
        this.sekolahs = data || [];
        this.meta = meta || {};
        this.component = `Detail${+this.tab === 1 ? 'Refleksi' : 'Visitasi'}`;
      });
    },

    onRefresh() {
      this.getListSekolah(true);
    },
  },
  watch: {
    tab: 'onChangeTab',
    pendampingan_ke: function() {
      this.getListSekolah();
    },
  },
};
</script>

<style scoped></style>
